import { getFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { LayerType } from '@/version-types';
import { ContextMenuPlugin } from '../context-menu';
import { type IRenderContextMenuItemArgs } from '../type';

export const saveToMySpaceItem = (
    { activeLayer, pickLayer, operateLayerType }: IRenderContextMenuItemArgs,
    identity: string,
) => {
    const { $t } = getLocaleStore();
    const framework = getFramework(identity);
    const layer = pickLayer || activeLayer;
    const disabled = !layer;

    if (!operateLayerType) return null;
    if (operateLayerType === LayerType.BACKGROUND_LAYER) return null;
    if (operateLayerType === LayerType.MAIN_LAYER) return null;
    if (operateLayerType === LayerType.WATERMARK) return null;
    if (framework.service.edgelessCanvas.isEdgelessMode) return null;

    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.addMySpace),
        type: 'saveToMySpace',
        icon: 'UploadFlowBold',
        onClick: () => {
            framework.service.registration.getInstance<ContextMenuPlugin>('ContextMenuPlugin').saveToMySpace();
        },
    };

    return item;
};
